import { Bot, Brain, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-100 via-blue-50 to-white" />
      
      {/* Animated background elements */}
      <div className="absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute h-2 w-2 bg-blue-400/20 rounded-full"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animation: `pulse ${2 + Math.random() * 3}s infinite`,
            }}
          />
        ))}
      </div>

      <div className="relative max-w-7xl mx-auto px-4 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-gray-900 space-y-8">
            <div className="flex items-center gap-2 text-blue-600">
              <Sparkles className="h-6 w-6" />
              <span className="text-lg font-medium">Next-Gen AI Solutions</span>
            </div>
            
            <h1 className="text-5xl font-bold leading-tight text-gray-900">
              Intelligent Agents & Chatbots That 
              <span className="bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                {" "}Transform Your Business
              </span>
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              Harness the power of AI to automate tasks, enhance customer support, and 
              streamline operations. Our intelligent agents work 24/7, learning and 
              adapting to deliver exceptional results.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button size="lg" className="bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto">
                  Start Building Your AI Agent
                </Button>
              </Link>
              <Link to="/case-studies">
                <Button 
                  size="lg"
                  variant="outline"
                  className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 w-full sm:w-auto"
                >
                  View Success Stories
                </Button>
              </Link>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-blue-200/30 blur-3xl rounded-full" />
            <div className="relative bg-white/80 backdrop-blur-sm p-8 rounded-2xl border border-blue-200 shadow-xl">
              <div className="grid gap-6">
                {[
                  {
                    icon: <Bot className="h-8 w-8 text-blue-600" />,
                    title: "24/7 Availability",
                    description: "AI agents that never sleep, ensuring constant support and task execution"
                  },
                  {
                    icon: <Brain className="h-8 w-8 text-blue-600" />,
                    title: "Continuous Learning",
                    description: "Adaptive systems that improve with every interaction"
                  },
                  {
                    icon: <Sparkles className="h-8 w-8 text-blue-600" />,
                    title: "Human-Like Interaction",
                    description: "Natural conversations that feel personal and engaging"
                  }
                ].map((feature, index) => (
                  <div 
                    key={index}
                    className="flex gap-4 p-4 rounded-xl bg-blue-50/50 border border-blue-100"
                  >
                    <div className="shrink-0">{feature.icon}</div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};